// 去除字符串中的空格
export const removeSpaces = (str: string) => {
  if (!str) return ''

  return str.replace(/\s/g, '')
}

// 将\\n转换成\n
export const filterNewLine = (rawText: string) => {
  if (!rawText) return ''

  // 第一步：将字面量的 "\n" 转换为真正的换行符
  let text = rawText.replace(/\\n/g, '\n')

  // 第二步：处理双换行，在 textarea 中显示为段落间距
  // 保持双换行作为段落分隔
  text = text.replace(/\n\n/g, '\n\n')

  return text
}
